/*!
=========================================================
* 仕入先マスタ 新規登録
=========================================================
*/
import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardTitle,
  Table,
  Row,
  Col,
  Modal, ModalBody, ModalFooter
} from "reactstrap";
import ButtonWithTooltip from '../FormParts/ButtonWithTooltip';
import InputText from '../FormParts/InputText';
import InputSelect from '../FormParts/InputSelect';
import InputRadio from '../FormParts/InputRadio';
import Request from '../../common/Request';
import SystemInfo from '../ViewParts/SystemInfo';
import {
  cst_prefecture,
  cst_supplier_type,
  cst_supplier_bank_account_type,
  cst_invoice_business_type
} from '../../variables/codes_map';

import FormatCode from "../../common/FormatCode";
import Definition from '../../common/Definition'
import CustomTd from '../ViewParts/CustomTd';
import WithRole from '../FormParts/ButtonWithRole';
import { getErrorCodes } from "../../variables/message";
import InputCheckBox from "../FormParts/InputCheckBox";
import GsuiteAuth from "../../components/Auth/GsuiteAuth";
import { GetMessage } from "../../variables/message";
import InputInvoice from "../ViewParts/InputInvoice";

const domain = "";

/*
*　クラス名：
*     Regist   ：新規登録・更新系クラス
*/
class Regist extends React.Component {
  /*
  *　関数・変数名：
  *     constructor     　：コンストラクタ関数
  *                         ロード時に1度だけ呼び出される
  *  パラメータ 説明：
  *     props            ：GETやPOSTなどのパラメータ入力値
  */  
  constructor(props) {
    /*
    *　関数・変数名：
    *     super     　      ：親のコンストラクターを呼び、thisを使えるようにする
    *  パラメータ 説明：
    *     props            ：GETやPOSTなどのパラメータ入力値
    */    
    super(props);

    /*
    *　関数・変数名：
    *     this.state    ：stateの初期設定
    *  KEY 説明：（※）は必須
    * 
    *     ▼共通設定
    *     valid             ：バリデーションの結果設定
    *                         true　→　正常     false   →　エラー
    *     regist_modal      ：登録・更新時の確認用モーダル表示
    *     error_modal       ：エラー用モーダル表示
    *     presave_modal     ：一時保存用モーダル表示
    * 
    *     ▼画面毎設定　
    *     supplier_id       ：更新画面用のパラメータ
    *     
    *     ▼共通設定
    *     data              ：更新画面用の元データ格納変数
    *     view              ：新規・更新の判定用変数
    *                         true : 更新   false ： 新規登録      
    */
    this.state = {
      valid: true,
      regist_modal: false,
      error_modal: false,
      presave_modal: false,
      supplier_id: "",
      data: {
        requiredData:{},
        errors:{},
        values:{
          supplier_type : cst_supplier_type[0].default,
          supplier_invoice_business_type: cst_invoice_business_type[0].default,
        }
      },
      post_data: {},
      error: {},
      view: false,
      requiredCheck:{},
      // 2022/07/12
      supplierEditIndex: undefined,
      pdata:[],
      bankList:[],
      bankBranchList:[],
      supplier_modal: false,
      supplierData:{
        edit: 0,
        values:{},
        requiredData:{},
        errors:{},
      },
      supplierInitSettings : {
        values:{
          user_branch_id: GsuiteAuth.get("user_branch_id"),
          user_branch_natural_id: GsuiteAuth.get("user_branch_natural_id"),
          supplier_bank: "",
          bank_natural_id: "",
          supplier_bank_branch: "",
          bank_branch_natural_id: "",
          supplier_bank_account_kana: "",
          supplier_bank_account_number: "",
          supplier_bank_account_type: "",
          antisocial_forces_flag: "0",
        },
        requiredData:{
//          supplier_bank : [GetMessage(2024)],
          bank_natural_id : [GetMessage(2024)],
//          supplier_bank_branch : [GetMessage(2024)],
          bank_branch_natural_id : [GetMessage(2024)],
          supplier_bank_account_kana: [GetMessage(2024)],
          supplier_bank_account_number: [GetMessage(2024)],
          supplier_bank_account_type: [GetMessage(2024)],
        },
        errors: {
//          supplier_bank : [GetMessage(2024)],
          bank_natural_id : [GetMessage(2024)],
//          supplier_bank_branch : [GetMessage(2024)],
          bank_branch_natural_id : [GetMessage(2024)],
          supplier_bank_account_kana: [GetMessage(2024)],
          supplier_bank_account_number: [GetMessage(2024)],
          supplier_bank_account_type: [GetMessage(2024)],
        }
      }
    };

  /*
  *　関数・変数名：
  *     this.[関数名]    ：this.stateやthis.propsを関数内で利用する場合に設定
  *  構文：
  * 　　this.[関数名] = this.[関数名].bind(this)
  */
    this.toggleRegistModal = this.toggleRegistModal.bind(this);
    this.togglePresaveModal = this.togglePresaveModal.bind(this);
    this.validateCallback = this.validateCallback.bind(this);
    this.validateSupplierCallback = this.validateSupplierCallback.bind(this);
    this.toggleSupplierModal = this.toggleSupplierModal.bind(this);
    this.supplier_list = this.supplier_list.bind(this)
    this.supplierRemove = this.supplierRemove.bind(this)
    this.toggleSupplierModalAdd = this.toggleSupplierModalAdd.bind(this)
    this.alert_text = this.alert_text.bind(this)
  }

  /*
  *　関数・変数名：
  *     UNSAFE_componentWillMount  ：初期ロード時の処理、render前に呼び出される
  *                                 初期化はconstructor内に記述
  *                                 再設定する際に利用
  * 　
  *     詳細は下記URLチェック
  *     https://ja.reactjs.org/docs/react-component.html#unsafe_componentwillmount
  */
  // life cycle method : before rendering 
  // static getDerivedStateFromProps(props, state){
  //   return
  // }
  
  // life cycle method: after rendering
  componentDidMount(){
    /*　ここは開発者が記述　*/
    Request.get('/api/bank', {}, res=>{
      this.setState({
        bankList:res.Data.map(element=>{
          return {
            value:element.bank_natural_id,
            label:element.bank_name
          }
        })
      });
    })
    Request.get('/api/bank/branch', {}, res=>{
      this.setState({
        bankBranchList:res.Data.map(element=>{
          return {
            value:element.bank_branch_natural_id,
            label:element.bank_branch_name,
            bank_natural_id:element.bank_natural_id
          }
        })
      });
    })

    if (this.props.match.params.supplier_id != undefined) {
      this.setState({ supplier_id: this.props.match.params.supplier_id });
      var url = domain + '/api/supplier/' + this.props.match.params.supplier_id;
      let params = {};
      Request.get(url, params, res => {
        this.setState({
          data: {
            ...this.state.data,
//            values:res.Data
             values:{
              ...res.Data["supplier"],
              org_banned_flag:res.Data["supplier"]["banned_flag"]
             }
          }, 
          view: true,
          pdata: [
            ...res.Data["supplier_bank"]
          ]
        }, ()=>{
          this.ButtonWithRole = WithRole(Button, this.props.buttons, this.state.view?this.state.data.values:undefined)
        });
        var url = domain + '/api/landmark/lastupdate/' + res.Data["supplier"].lastupdate_user_id;
        var params = {};
        Request.get(url, params, res => {
          this.setState({
            data:{
              ...this.state.data,
              values:{
                ...this.state.data.values,
                lastupdate_user:res.Data
              }
            }
          }, ()=>{
            this.setRequiredData()
            this.ButtonWithRole = WithRole(Button, this.props.buttons, this.state.view?this.state.data.values:undefined)
          });
        });

      });
    } else {
      this.setRequiredData()
    }
  }

  setRequiredData = async ()=>{
    const url = domain + '/api/supplier';
    const requiredCheckedData = await Request.getRequiredData(url, this.state.data)
    // console.log(requiredCheckedData)
    this.setState({
      data:requiredCheckedData
    })
  }
  /*
  *　関数・変数名：
  *     validate    ：バリデーションのエラー判定用関数
  *                   エラーがあるか無いかの判定のみ
  *                   バリデーションのチェックは、フォームのコンポーネント側に実装 
  */  
  validate() {
    console.log(this.state.data);
    let message = getErrorCodes(this.state.data.errors)
    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  /*
  *　関数・変数名：
  *     validate_[定義名]    ：Inputフォームのバリデーション結果を受け取るためのCallback関数
  *                            専用コンポーネント（InputTelやInputNumberなど）の場合に記述方法
  *                           render内のvalidateCallback関数に設定した名前を追記する
  *  パラメータ 説明：
  *         valid        ：バリデーション結果
  *          tel         ：入力値 
  * 
  */  
  validateCallback(newData, callback=()=>{}){
    const data = this.state.data;

    let errors = newData.errors ? newData.errors : {};

    let {
      supplier_invoice_business_type,
      supplier_invoice_registration_number
    } = newData.values


    if (supplier_invoice_business_type == "1" && supplier_invoice_registration_number) {
/*
      if ( supplier_invoice_registration_number == null || supplier_invoice_registration_number.length <= 0) {
        errors = {supplier_invoice_registration_number:[GetMessage(2601)]}
      }
      else if (!supplier_invoice_registration_number.match(/^T\d{13}$/)) {
        errors = {supplier_invoice_registration_number:[GetMessage(2035)]}
      }
*/
      if (supplier_invoice_registration_number.length>0 && !supplier_invoice_registration_number.match(/^T\d{13}$/)) {
        errors = {supplier_invoice_registration_number:[GetMessage(2035)]}
      }    
    }
/*
    else {
      newData.values.supplier_invoice_registration_number = null;
    }
*/
    this.setState({
      data:{
        ...data,
        ...newData,
        errors:{...errors}
      }
    }, ()=>{callback();console.log(this.state.data)})
  }

  /*
  *　関数・変数名：
  *     toggle[任意モーダル名]  ：　Class内でモーダルを表示の簡易版
  *                                確認及び結果表示のみに利用
  *                                複雑な処理をする場合は、専用モーダルかDialogBaseを利用
  *     
  */   
  toggleRegistModal() {
    this.setState({
      regist_modal: !this.state.regist_modal
    });
  }
  togglePresaveModal() {
    this.setState({
      presave_modal: !this.state.presave_modal
    });
  }

  /*
  *　関数・変数名：
  *     regist ： 登録及び更新APIのリクエスト用関数
  *     
  */   
  regist() {
    const {
      data,
      pdata,
      view
    } = this.state
    console.log(data.values)
    // TODO 登録API呼び出し
    const url = domain + '/api/supplier';
    if(view === false) {
      Request.post(url, 
        {
          supplier: {...data.values},
          supplier_bank: [...pdata]
        }, 
        res => {
        if (res.Code>=800) {
          this.setState({
            data:{
              ...data,
              errors:res.Data
            },
            pdata: { ...pdata}
          })
        } else {
          this.props.pageChangeAlert.current.inactivate();
          this.props.history.push('/supplier');
        }
      });
    } else {
      Request.put(url + "/" + data.values.ulid, 
      {
        supplier: {...data.values},
        supplier_bank: [...pdata]
      }, 
      res => {
        if (res.Code>=800) {
          if (res.Code != 815){
            this.setState({
              data:{
                ...data,
                errors:res.Data
              },
              pdata: { ...pdata}
            })
          }else{
            this.props.alertModal.current.showErrorModal({message:res.Data.error});
          }
        } else {
          // update success
          this.props.pageChangeAlert.current.inactivate();
          this.props.history.push(`/supplier/detail/${this.props.match.params.supplier_id}`) 
        }
      });
    }
  }

  /*
  *　関数・変数名：
  *     button_name ：this.state.viewを利用し、ボタン名の判定用関数
  *     
  */   
  button_name() {
    if (this.state.view === false) {
      return "登録";
    } else {
      return "更新";
    }
  }

  alert_text () {
    let {
      supplier_invoice_business_type,
      supplier_invoice_registration_number
    } = this.state.data.values

    if (supplier_invoice_business_type=="1" && (supplier_invoice_registration_number == null || supplier_invoice_registration_number.length<=0)) {
      return (<div style={{color:"red"}}>適格事業者番号が空欄ですがよろしいですか？</div>)
    }
    return "";
  }

  /*
  *　関数・変数名：
  *     button_name ：this.state.viewを利用し、タイトルの判定用関数
  *     
  */   
  set_title() {
    if (this.state.view === false) {
      return "仕入先マスタ新規登録";
    }
    return "仕入先マスタ更新";
  }

  /*
  *　関数・変数名：
  *     render ：react.Componentで用意されているrender関数
  *              この関数内のタグが表示される
  *     
  */   
  render() {
    const SupplierList = this.supplier_list
    const ButtonWithRole = this.ButtonWithRole || WithRole(Button, this.props.buttons, this.state.view?this.state.data.values:undefined)
    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h3">{this.set_title()}</CardTitle>
                </CardHeader>
                <Col md="11" className="detail">
                  <SystemInfo
                    id_title='仕入先ID'
                    id_value={this.state.data.values.supplier_natural_id}
                    update_timestamp={this.state.data.values.update_timestamp}
                    update_user={this.state.data.values.lastupdate_user && this.state.data.values.lastupdate_user.name}
                    update_user_picture={this.state.data.values.lastupdate_user && this.state.data.values.lastupdate_user.picture}
                    visible={this.state.view} />

                  <CardTitle tag="h4">管理情報</CardTitle>
                  <Table>
                    <tbody>
                      <tr>
                        {/* <th>管理情報</th> */}
                        <CustomTd label="メモ"
                            name="SUPPLIER__system_memo"
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText 
                                validateCallback={this.validateCallback}
                                multiline={true} 
                                validateType="regist" />
                            } />                      
                      </tr>
                      <tr>
                        <CustomTd label='削除フラグ'
                          name='SUPPLIER__delete_flag'
                          copy={false}
                          value={
                            <InputCheckBox 
                              validateCallback={this.validateCallback} 
                              checkedValue={1}
                              uncheckedValue={0}
                              rootData={this.state.data}
                            />
                          }
                        />
                      </tr>
                      <tr>
                        <CustomTd label='出入禁止フラグ'
                          name='SUPPLIER__banned_flag'
                          copy={false}
                          value={
                            <InputCheckBox 
                              validateCallback={this.validateCallback} 
                              checkedValue={1}
                              uncheckedValue={0}
                              rootData={this.state.data}
                            />
                          }
                        />
                      </tr>
                    </tbody>
                  </Table>
                  <CardTitle tag="h4">会社情報</CardTitle>
                  <Table>
                    <tbody>
                      <tr>
                        {/* <th rowSpan="5">仕入先情報</th> */}
                        <CustomTd label="仕入先種別（法人・個人）"
                            name="SUPPLIER__supplier_type"
                            copy={false}
                            rootData={this.state.data}
                            value={
                                <InputRadio options={cst_supplier_type}
                                  validateCallback={this.validateCallback} 
                                  />
                            } />
                      </tr>
                      <tr>
                        <CustomTd label="会社名"
                            name="SUPPLIER__supplier_name"
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText 
                                validateCallback={this.validateCallback} 
                                rootData={this.state.data}
                                validateType="regist"
                                hasKanaInput={true}
                              />
                              } />
                      </tr>
                      <tr>
                        <CustomTd label="会社名（カナ）"
                            name="SUPPLIER__supplier_name_kana"
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText 
                                validateCallback={this.validateCallback} 
                                rootData={this.state.data}
                                validateType="regist" />
                              } />
                      </tr>
                      <tr>
                        <CustomTd label="電話番号1"
                            name="SUPPLIER__supplier_tel"
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText 
                                validateCallback={this.validateCallback}
                                
                                validateType="regist" />
                              } />
                      </tr>
                      <tr>
                        <CustomTd label="電話番号2"
                            name="SUPPLIER__supplier_tel2"
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText 
                                validateCallback={this.validateCallback}
                                
                                validateType="regist" />
                              } />
                      </tr>
                      <tr>
                        <CustomTd label="FAX番号"
                            name="SUPPLIER__supplier_fax"
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText  
                                validateCallback={this.validateCallback} 
                                rootData={this.state.data}
                                validateType="regist" />
                            } />
                      </tr>
                      <tr>
                        <CustomTd label='メールアドレス'
                            name='SUPPLIER__supplier_email'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText
                                validateCallback={this.validateCallback} 
                                validateType='regist'
                              />
                            }
                        />
                      </tr>
                      <tr>
                       <CustomTd label="郵便番号"
                            name="SUPPLIER__supplier_zip_code"
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText 
                                validateCallback={this.validateCallback} 
                                rootData={this.state.data}
                                validateType="regist" />
                            } />
                      </tr>
                      <tr>
                        {/* <th rowSpan="3">所在地</th> */}
                        <CustomTd label="都道府県"
                            name="SUPPLIER__supplier_prefecture"
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputSelect
                                options={cst_prefecture}
                                validateCallback={this.validateCallback}
                                rootData={this.state.data} 
                                isSearchable={true}
                                isNull={true}
                                validateType="regist" 
                              />
                            } />
                      </tr>
                      <tr>
                        <CustomTd label="市区町村"
                            name="SUPPLIER__supplier_city"
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText 
                                validateCallback={this.validateCallback} 
                                rootData={this.state.data}
                                validateType="regist" />
                            } />                        
                      </tr>
                      <tr>
                       <CustomTd label="番地"
                            name="SUPPLIER__supplier_address"
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText 
                                validateCallback={this.validateCallback} 
                                rootData={this.state.data}
                                validateType="regist" />
                            } />                           
                      </tr>
                      <tr>
                        <CustomTd label="適格事業者区分"
                            name="SUPPLIER__invoice_business_type"
                            rootData={this.state.data}
                            value={
                                <InputInvoice
                                    label="適格事業者区分"
                                    labelOn={false}
                                    rows={false}
                                    names={{
                                      payment_type: false,
                                      business_type: "SUPPLIER__supplier_invoice_business_type",
                                      registration_number: "SUPPLIER__supplier_invoice_registration_number",
                                      with_unconfirmed : "SUPPLIER__supplier_invoice_business_type"
                                    }}
                                    rootData={this.state.data}
                                    validateCallback={this.validateCallback}
                                    visible={true}
                                    disabled={false}
                                    />
                            } />
                      </tr>
                    </tbody>
                  </Table>
                  <Row>
                    <Col md="6">
                        <CardTitle tag="h4" className="float-left sub">口座情報</CardTitle>
                    </Col>
                    <Col md="6">
                        <ButtonWithTooltip onclick={() => { this.toggleSupplierModalAdd(); }} class="btn-search btn-facebook float-right" id="tmp" icon="fas fa-plus" label="追加" message="口座情報を追加します。" />
                    </Col>
                  </Row>
                  <Table>
                    <tbody>
                      <tr>
                        <th className="sub">口座種別/口座番号</th>
                        <th className="sub">銀行名/支店名</th>
                        <th className="sub">口座名義（カナ）</th>
                        {/*<th className="sub">反社確認</th>*/}
                        <th className="sub">削除</th>
                      </tr>
                    {this.state.pdata.length>0 && this.state.pdata.map((data,index)=> {
                      return <SupplierList data={data} index={index} key={index}/>
                    })}
                    </tbody>
                  </Table>

                  <Row md="12">
                    <Col md="6" className="text-center">
                      <Button color="secondary" onClick={() => { 
                        if(this.state.view === false){
                          this.props.history.push('/supplier') 
                        } else {
                          this.props.history.push(`/supplier/detail/${this.props.match.params.supplier_id}`) 
                        }
                      }}>キャンセル</Button>
                    </Col>
                    <Col md="6" className="text-center">
                      <ButtonWithRole
                        button_id={this.state.view?"BTN_M2_04_04350":"BTN_M2_02_04290"}
                        color="info"
                        onClick={() => {
                          if(this.validate()){
                            this.toggleRegistModal()
                          }
                        }}
                      >
                        {this.button_name()}
                      </ButtonWithRole>
                    </Col>
                  </Row>
                </Col>
              </Card>
            </Col>
          </Row>
        </div>

        {/* 登録・更新確認用モーダル */}
        <Modal isOpen={this.state.regist_modal} toggle={this.toggleRegistModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleRegistModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">{this.button_name()}</h5>
          </div>
          <ModalBody>
            <p>{this.button_name()}しますか？</p>
            {this.alert_text()}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleRegistModal}>
              いいえ
            </Button>
            <ButtonWithRole 
              // button_id={this.state.view?"BTN_M2_04_04370":"BTN_M2_02_04310"}
              color="info" 
              onClick={() => { this.toggleRegistModal(); this.regist(); }}>
              はい
            </ButtonWithRole>
          </ModalFooter>
        </Modal>
        {this.render_supplier_modal()}
      </>
    );
  }
  /* 2022/07/12 銀行情報登録 */
  render_supplier_modal () {
    const selectableBankBranch = this.state.bankBranchList.filter(element=>element.bank_natural_id==this.state.supplierData.values.bank_natural_id)
    return (<>
        <Modal isOpen={this.state.supplier_modal} toggle={this.toggleSupplierModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleSupplierModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">口座情報</h5>
          </div>
          <ModalBody>
            <Row className="detail">
              <Col md="12" className="text-center">
                <Table>
                  <tbody>
                    <tr>
                      {/* <th rowSpan="7">支払情報</th> */}
                      <CustomTd label='銀行名'
                          name='SUPPLIER_BANK__bank_natural_id'
                          copy={false}
                          rootData={this.state.supplierData}
                          value={
                            <InputSelect
                              options={this.state.bankList}
                              rootData={this.state.supplierData}
                              validateCallback={this.validateSupplierCallback} 
                              validateType='regist'
                              isSearchable={true}
                              isCreatable={false}
                            />
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='支店名'
                          name='SUPPLIER_BANK__bank_branch_natural_id'
                          copy={false}
                          rootData={this.state.supplierData}
                          value={
                            <InputSelect
                              key={`bank-branch-${this.state.supplierData.values.bank_natural_id}`}
                              options={selectableBankBranch}
                              rootData={this.state.supplierData}
                              validateCallback={this.validateSupplierCallback} 
                              validateType='regist'
                              isSearchable={true}
                              isCreatable={false}
                            />
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='口座名義（カナ）'
                          name='SUPPLIER_BANK__supplier_bank_account_kana'
                          copy={false}
                          rootData={this.state.supplierData}
                          value={
                            <InputText
                              rootData={this.state.supplierData}
                              validateCallback={this.validateSupplierCallback} 
                              validateType='regist'
                            />
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='口座種別'
                        name='SUPPLIER_BANK__supplier_bank_account_type'
                        copy={false}
                        rootData={this.state.supplierData}
                        value={
                          <InputSelect
                            options={cst_supplier_bank_account_type}
                            validateCallback={this.validateSupplierCallback} 
                            validateType='regist'
                            isSearchable={true}
                          />
                        }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='口座番号'
                        name='SUPPLIER_BANK__supplier_bank_account_number'
                        copy={false}
                        rootData={this.state.supplierData}
                        value={
                          <InputText
                            validateCallback={this.validateSupplierCallback} 
                            validateType='regist'
                          />
                        }
                      />
                    </tr>
                    {/* 
                    <tr>
                      <CustomTd label='反社確認'
                        name='SUPPLIER_BANK__antisocial_forces_flag'
                        copy={false}
                        rootData={this.state.supplierData}
                        labelOn={true}
                        value={                          
                        <InputCheckBox
                          label=''
                          labelOn={false}
                          checkedValue={'1'}
                          uncheckedValue={'0'}
                          validateCallback={this.validateSupplierCallback}
                          validateType={"regist"} 
                        />
                        }
                      />
                    </tr>
                    */}
                  </tbody>
                </Table>
            </Col>
            <Col md="12" className="text-center">
        　　　 <Button color="info" 
                onClick={() => {
                  if ( this.validateSupplier () ) {
                    this.supplierSelected();
                    this.toggleSupplierModal();
                  }
                }} 
                className="float-right">
                  {this.state.supplierData.edit ==1? "口座情報更新":"口座情報追加"}
                </Button>
            </Col>
          </Row>
          </ModalBody>
          <ModalFooter>
          </ModalFooter>
        </Modal>
    </>);
  }
  validateSupplier () {
    console.log("validateSupplier");
    let message = getErrorCodes(this.state.supplierData.errors)
    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }
  validateSupplierCallback (newData, callback=()=>{}) {
    console.log(newData);
    console.log("validateSupplierCallback");

    const data = this.state.supplierData;

    this.setState({
      supplierData:{
        ...data,
        ...newData
      }
    }, ()=>callback())

  }
  toggleSupplierModal () {
    this.setState({
      supplier_modal: !this.state.supplier_modal
    });
  }
  toggleSupplierModalAdd () {
    this.setState({
      supplierEditIndex: undefined,
      supplier_modal: true,
      supplierData:{
        ...this.state.supplierInitSettings,
        edit: 0,
      },
    });
  }

  supplier_list({data={},index}){
    const {
      id,
      supplier_bank_account_kana,
    } = data
    const align={
      verticalAlign: "top",
      textAlign: "left"
    }
    return (
      <>
        {data.delete_flag !== true && (
        <tr key={index}>
          <td style={align}><span dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_supplier_bank_detail', data)}} /></td>
          <td style={align}><span dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_supplier_bank',data)}} /></td>
          <td style={align}>{supplier_bank_account_kana}</td>
          {/*
          <td style={align}>{FormatCode.decode("cst_supplier_antisocial_forces_flag",data["antisocial_forces_flag"])}</td>
           */}
          <td>
            <button type="button" className="btn btn-sm" data-dismiss="modal" aria-label="Close" onClick={() => {this.supplierEdit(index)}}>
            編集
            </button>
            <button type="button" className="btn btn-sm" data-dismiss="modal" aria-label="Close" onClick={() => {this.supplierRemove(index)}}>
            削除
            </button>
          </td>
        </tr>
      )}
      </>
    );
  }
  supplierSelected() {
    console.log(this.state.supplierData);
    if (Object.keys(this.state.supplierData.errors).length===0){
      const {
        supplierEditIndex,
        pdata,
      } = this.state
      let { values } = this.state.supplierData;
      const selectableBankBranch = this.state.bankBranchList.filter(element=>element.bank_natural_id==this.state.supplierData.values.bank_natural_id)

//      values.bank_natural_id = values.bank_natural_id === values.supplier_bank? undefined : values.bank_natural_id
//      values.bank_branch_natural_id = values.bank_branch_natural_id === values.supplier_bank_branch? undefined : values.bank_branch_natural_id
      values.supplier_bank = this.state.bankList.filter(bank=>bank.value==values.bank_natural_id)[0].label
      values.supplier_bank_branch = selectableBankBranch.filter(branch=>branch.value==values.bank_branch_natural_id)[0].label

      this.setState({
        ...(
          supplierEditIndex===undefined
          ? {pdata: [...pdata, values]}
          : {pdata: [...pdata.map((supplier, index)=>{
            return supplierEditIndex!==index?supplier:values
          })]}
        ),
        supplierData:{
          ...this.state.supplierInitSettings,
        },
        supplierEditIndex:supplierEditIndex!==undefined?undefined:supplierEditIndex
      });
    } else {
      this.props.alertModal.current.showErrorModal({messageNo:2401})
    }
  }
  supplierEdit(index){
    this.setState({
      supplierEditIndex:index,
      supplierData:{
        edit: 1,
        values:{
          ...this.state.supplierData.values,
          ...this.state.pdata[index],
        },
        errors:{}
      },
      supplier_modal: !this.state.supplier_modal
    });
  }
  // 2022-07-21
  supplierRemove(key){
    this.props.alertModal.current.confirmCheck({messageNo:2411},()=>{
      if(key !== undefined){
        let supplierBanks = [];
        this.state.pdata.forEach((bank,index)=>{
          if (key==index) {
            if ( bank["id"] ) {
              supplierBanks.push({...bank, delete_flag: true});
            }
          }
          else {
            supplierBanks.push({...bank});
          }
        });

        console.log(supplierBanks);
        
        this.setState({
          pdata: supplierBanks
        });
      }
    })
  }
}

export default Regist;
